import { search } from 'angular-animate';

const $inject = ['$q', '$http', 'apiService'];

const companyReferenceListService = function ($q, $http, apiService) {
  let service = {};
  service.get = get;

  function get(params) {
    const apiUrl = apiService.getUrl('companyreferences');

    return $http.get(apiUrl, { params: params }).then((response) => {
      return response.data;
    });
  }

  return service;
};

companyReferenceListService.$inject = $inject;

export default companyReferenceListService;



// WEBPACK FOOTER //
// ./src/services/companyReferenceListService.js